<template>
  <div class="columns is-multiline is-main-content is-marginless is-paddingless"
    v-if="critereRecherche">
    <div class="column is-12 pdb-0"
      :class="[{'hauteur-haut-brief-filtre': errors.length === 0},
      {'hauteur-haut-brief-filtre-errors': errors.length > 0}]">
      <div class="column is-12 mgt-5px">
        <a @click="$emit('toggleFiltre')">
          <b-icon class="icon is-pulled-right has-text-icon-more" icon="close"></b-icon>
        </a>
        <span class="has-text-weight-bold is-size-4">
          {{ $t('general.filtre.title') }}
        </span>
      </div>
      <div class="column is-12 pdt-0">
        <span class="has-text-icon-more is-size-7">
          {{ $t('general.filtre.sousTitle') }}
        </span>
      </div>
      <div class="column is-12" v-if="hasError">
        <error-msg-component :messages="errors"
          :error="hasError"
          :title="'general.problemOccurred'"
          :withEmplyFields="true"
          @close="closeErrorMsg"/>
      </div>
    </div>
    <div class="column is-12 overflow-auto is-marginless"
      :class="[{'hauteur-brief-filtre': errors.length === 0},
        {'hauteur-brief-filtre-errors': errors.length > 0}]">
      <div class="column is-12 pdb-0">
        <input-periode
          v-model="critereRecherche.dates"
          :label="$t('listeCommandeAchat.filtre.periode')">
        </input-periode>
      </div>
      <div class="column is-12 pdb-0">
        <query-tag-input :label="$t('listeCommandeAchat.filtre.bailleur')"
          v-model="critereRecherche.tiersId"
          field="nomCommercial"
          :query="(search) => getAll({
            query: {
              auto: search,
              societeId: societeActiveId,
              type: constantes.TIERS_TYPE_FOURNISSEUR,
              sousType: constantes.sousTypesBailleurs,
            }
          })">
          <template slot-scope="props">
            <div>{{ props.option.nomCommercial }}</div>
          </template>
        </query-tag-input>
      </div>
      <div class="column is-12 pdb-0">
        <libelle-tag-input
          :label="$t('listeCommandeAchat.filtre.etat')"
          :items="constantes.COMMANDE_ACHAT_BAILLEUR_ETAT"
          v-model="etatsSelected">
        </libelle-tag-input>
      </div>
      <div class="column is-12 pdb-0">
        <agence-tag-input
          :label="$t('listeCommandeAchat.filtre.agence')"
          :items="agencesSelectionnees"
          v-model="critereRecherche.agencesId">
        </agence-tag-input>
      </div>
    </div>
    <div class="column is-12 border-pied pdt-0 hauteur-bas-brief-filtre">
      <button class="button mgl-10px mgt-10px is-addOrEdit has-text-white"
        @click="appliquerCritere()">
        {{ $t('general.button.appliquer') }}
      </button>

      <button @click="viderCritere()"
              class="button border-none mgt-10px has-text-icon-more pd-10px">
        {{ $t('general.button.reinitialiser') }}
      </button>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import moment from 'moment';
import cloneDeep from 'lodash/cloneDeep';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import messageErreur from '@/services/general/messageErreur';
import { getAll } from '@/api/tiers/index';
import genererCritereRecherche
  from '@/services/baux/commandeAchat/genererCritereRechercheCommandeAchat';
import { TIERS_TYPE_FOURNISSEUR, LISTE_SOUS_TYPE_BAILLEUR } from '@/configuration/tiers/tiersConf';
import { SET_CRITERE_RECHERCHE } from '@/store/modules/baux/commandeAchatBailleur-mutation-type';
import libelleTagInput from '@/components/general/tagInput/libelleTagInput';
import agenceTagInput from '@/components/general/tagInput/agenceTagInput';
import queryTagInput from '@/components/general/tagInput/queryTagInput';
import inputPeriode from '@/components/general/inputPeriode';
import { COMMANDE_ACHAT_BAILLEUR_ETAT } from '@/configuration/commande/commandeConf';

const Parametres = createNamespacedHelpers('parametres');
const Societe = createNamespacedHelpers('societe');
const CommandeAchatBailleur = createNamespacedHelpers('commandeAchatBailleur');

export default {
  data() {
    return {
      errors: [],
      hasError: false,
      critereRecherche: null,
      constantes: {
        TIERS_TYPE_FOURNISSEUR,
        COMMANDE_ACHAT_BAILLEUR_ETAT,
        sousTypesBailleurs: LISTE_SOUS_TYPE_BAILLEUR.map(el => el.code),
      },
      etatsSelected: [],
      getAll,
    };
  },
  components: {
    libelleTagInput,
    agenceTagInput,
    errorMsgComponent,
    queryTagInput,
    inputPeriode,
  },
  computed: {
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    ...CommandeAchatBailleur.mapGetters({
      criteresRechercheFromStore: 'criteresRecherche',
    }),
    ...Societe.mapGetters({
      agencesSelectionnees: 'agenceActive',
      societeActiveId: 'societeActiveId',
    }),
  },
  methods: {
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
      loadParametreUtilisateur: 'loadParametreUtilisateur',
    }),
    ...CommandeAchatBailleur.mapMutations({
      setCritereRecherche: SET_CRITERE_RECHERCHE,
    }),
    closeErrorMsg() {
      this.errors = [];
      this.hasError = false;
    },
    checkError() {
      if (this.critereRecherche.dates.dateFin
        && this.critereRecherche.dates.dateDebut
        && moment(this.critereRecherche.dates.dateDebut)
          .isAfter(moment(this.critereRecherche.dates.dateFin))) {
        this.errors.push({
          message: 'listeCommandeAchat.filtre.error.date',
        });
        this.hasError = true;
      }
    },
    appliquerCritere() {
      this.checkError();
      if (this.hasError) return;
      this.critereRecherche.etat = this.etatsSelected
        .map((e) => {
          return e.code;
        });
      this.setCritereRecherche(this.critereRecherche);
      this.$emit('recherche', this.critereRecherche);
    },
    viderCritere() {
      this.critereRecherche = genererCritereRecherche();
      this.etatsSelected = [];
    },
    getEtatTag() {
    },
    initializeFiltre() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.critereRecherche = cloneDeep(this.criteresRechercheFromStore);
        if (this.critereRecherche.etat.length > 0) {
          this.etatsSelected = this.constantes.COMMANDE_ACHAT_BAILLEUR_ETAT.filter((e) => {
            return this.critereRecherche.etat.includes(e.code);
          });
        }
        loadingComponent.close();
      } catch (e) {
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
  },
  mounted() {
    this.initializeFiltre();
  },
};
</script>
